import { FieldSelect } from '@/components/looker/field-select';
import { TaskCardType } from '@/task-manager/entities/task-card-type';

export type TaskCardTypeFilterProps = {
  value?: TaskCardType;
  onChange: (value?: TaskCardType) => void;
};

export function TaskCardTypeFilter({
  value,
  onChange,
}: TaskCardTypeFilterProps) {
  return (
    <FieldSelect
      data-testid="task-card-type-filter"
      label="Card type"
      placeholder="Filter by card type"
      value={value}
      isClearable={true}
      options={Object.values(TaskCardType).map((value) => ({
        label: value.replace(/([a-z0-9])([A-Z])/g, '$1 $2'),
        value,
      }))}
      onChange={(v) =>
        onChange(
          v
            ? Object.values(TaskCardType).find((cardType) => cardType === v)
            : undefined,
        )
      }
    />
  );
}
